import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_BREAKPOINTS, CONTAINER_MAX } from '@/constants/breakpoints';
import {
  containerPaddingInline,
  flexBetween,
  flexColumn
} from '@/styles/common';

const commonLinkStyles = css`
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;

export const Wrapper = styled.footer<{
  $hasFixedBottomBar: boolean;
}>`
  width: 100%;
  background: var(--bg-main);
  padding-block: 100px
    ${({ $hasFixedBottomBar }) => ($hasFixedBottomBar ? '130px' : '50px')};
  ${containerPaddingInline};
  ${flexColumn};
  gap: 40px;

  @media (max-width: ${CONTAINER_MAX.desktop}) {
    border-top: 1px solid var(--border-main);
    padding-block: 30px
      ${({ $hasFixedBottomBar }) => ($hasFixedBottomBar ? '105px' : '30px')};
    align-items: flex-start;
    gap: 25px;
  }

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) and (max-width: ${CONTAINER_MAX.desktop}) {
    padding-block: 40px
      ${({ $hasFixedBottomBar }) => ($hasFixedBottomBar ? '130px' : '40px')};
    gap: 30px;
  }
`;

export const Section = styled.div`
  ${flexBetween};
  align-items: flex-start;

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) and (max-width: ${CONTAINER_MAX.desktop}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    width: 100%;
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid var(--border-main);
`;

export const ContactsWrapper = styled.div`
  display: flex;
  gap: 40px;

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) and (max-width: ${CONTAINER_MAX.desktop}) {
    align-items: center;
    width: 100%;

    > :nth-child(2) {
      margin-left: auto;
    }
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    margin-top: 30px;
    flex-direction: column;
    gap: 20px;

    > :nth-child(3) {
      order: 2;
    }

    > :nth-child(4) {
      order: 1;
    }
  }
`;

export const ContactItem = styled(Typography).attrs({ variant: 'title4' })`
  color: var(--textAndLabels-main);
  ${commonLinkStyles}
`;

export const CopyRight = styled(Typography).attrs({ variant: 'body3' })`
  color: var(--textAndLabels-tertiary);

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) and (max-width: ${CONTAINER_MAX.desktop}) {
    order: 1;
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    margin-top: 20px;
    order: 1;
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
  gap: 20px;

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) and (max-width: ${CONTAINER_MAX.desktop}) {
    flex-wrap: wrap;
    gap: 20px 30px;
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FooterLink = styled(Typography).attrs({ variant: 'body3' })`
  width: max-content;
  color: var(--textAndLabels-tertiary);
  ${commonLinkStyles}
`;
